import get from 'lodash.get';

// Global Types
import { AppActionTypes } from 'services/types';

// Global Constants
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
import { RESET_STATE } from 'services/auth/constants';

// Local Types
import { ErrorState, RequestHeaders } from './types';
import { RESET_ERROR_BY_NAMESPACE } from './constants';

const initialState: ErrorState = {};

function errorReducer(
    state = initialState,
    action: AppActionTypes
): ErrorState {
    const { type, payload } = action;
    const matches = /(.*)_(REQUESTED|FAILED)/.exec(type);

    // Reset error when either of these actions happen
    if (type === SET_CURRENT_ORGANIZATION_ID || type === RESET_STATE) {
        return initialState;
    }

    // Reset error by namespace
    if (type === RESET_ERROR_BY_NAMESPACE) {
        const { namespace } = action.payload;

        if (Array.isArray(namespace)) {
            const namespaces = namespace.reduce(
                (previousValue, currentValue) => {
                    return {
                        ...previousValue,
                        [currentValue]: null
                    };
                },
                {}
            );

            return {
                ...state,
                ...namespaces
            };
        }

        return {
            ...state,
            [namespace]: null
        };
    }

    // not a *_REQUEST / *_FAILURE actions, so we ignore them
    if (!matches) return state;

    const [, requestName, requestState] = matches;

    const data = get(payload, 'response.data');

    const message = get(
        data,
        'message',
        'There was an error. Please try again later.'
    );
    const details = get(data, 'data.details');
    const statusCode = get(data, 'statusCode');
    const errors = get(data, 'errors');
    const headers: RequestHeaders = get(payload, 'config.headers');

    const error = {
        message,
        details,
        statusCode,
        errors,
        headers
    };

    return {
        ...state,
        // Store error
        [requestName]: requestState === 'FAILED' ? error : null
    };
}

export default errorReducer;
